import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsSmBasEncroachment from "../creation-inner-pages/tms-bas-encroachment";
import TmsSmRalEncroachmentList from "../created-list-inner-pages/tms-sm-bas-encroachment-list";
const BuildingEncroachment = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Encroachment Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsSmRalEncroachmentList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Building Encroachment Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsSmBasEncroachment setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default BuildingEncroachment;
